import React, { useState, useEffect } from 'react';

// Components
import Sidebar from '../../components/Sidebar';
import Main from './OfficeEquipForm/Main';
import Form from './OfficeEquipForm/Form';

// Utils
import {
  getDataWithComp,
  getAlert,
  getMaxOeNo,
  getEmpByType
} from '../../../utils/SamuiUtils';

const OfficeEquipForm = () => {
  const [mode, setMode] = useState('');
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataDetailList, setDataDetailList] = useState([]);
  const [maxOeNo, setMaxOeNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode('S');
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getEmpByType('7');
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }

      const detailList = await getDataWithComp('API_1602_WTDOC_D', `AND WTDocType_Name = 'Office Equip' AND Item_Is_Return = 0 ORDER BY Line ASC`);
      if (detailList && detailList.length > 0) {
        setDataDetailList(detailList);
      }

      // หาค่าสูงของ WTDocNo ใน WTDoc_H สำหรับ OE (ใบเบิกวัสดุใช้ภายใน)
      const findMaxOeNo = await getDataWithComp('WTDoc_H', `AND WTDoc_Type = '7' ORDER BY WTDoc_No DESC`);
      const maxOe = getMaxOeNo(findMaxOeNo);
      setMaxOeNo(maxOe);
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const onPageInsert = () => {
    setMode('I');
  };

  const onPageUpdate = (wtDocNo) => {
    setMaxOeNo(wtDocNo);
    setMode('U');
  };

  return (
    <div>
      <div className="OfficeEquipForm">
        <div className="wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="container">
              <div className="page-inner">
                {mode === 'S' ? (
                  <Main
                    name={'ใบเบิกวัสดุใช้ภายใน'}
                    dataMasterList={dataMasterList}
                    dataDetailList={dataDetailList}
                    onPageInsert={() => onPageInsert()}
                    onPageUpdate={(wtDocNo) => onPageUpdate(wtDocNo)}
                  />
                ) : (
                  <Form
                    callInitialize={initialize}
                    mode={mode}
                    name={'ใบเบิกวัสดุใช้ภายใน'}
                    wtDocNo={maxOeNo}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfficeEquipForm;
